import * as angular from 'angular';

import { Group, ComponentDefinition } from '../../models';

class GroupMatrixStatusController implements angular.IComponentController {
    group: Group;
    title: string;

    static $inject = [];
}

export const wtGroupMatrixStatus: ComponentDefinition = {
    componentId: 'wtGroupMatrixStatus',
    controller: GroupMatrixStatusController,
    template: require('./groupMatrixStatus.component.html'),
    controllerAs: 'vm',
    bindings: {
        group: '=',
        title: '@?'
    }
};
